import { connect } from 'react-redux';
import Lyp from './Lyp';

const mapStateToProps = ({ content: { lyp, siteStaticContent: { lypUrl }}}) => ({
  title: lyp.title,
  imageUrl: lyp.imageUrl,
  callToActionText: lyp.btnText,
  callToActionUrl: lypUrl
});

export default connect(mapStateToProps)(Lyp);
